import React from "react"
import PropTypes from "prop-types"
import { Div, P, A, Icon } from "./styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons"

const Breadcrumb = ({ pages, preTitle }) => {
  return (
    <Div preTitle={preTitle}>
      <P>
        {pages.map((page, index) => (
          <>
            {page.onClick ? (
              <A onClick={page.onClick} key={index} currentPage={page.currentPage}>
                {page.name}
              </A>
            ) : (
              <A href={page.url} key={index} currentPage={page.currentPage}>
                {page.name}
              </A>
            )}
            {index < pages.length - 1 && (
              <Icon>
                <FontAwesomeIcon icon={faChevronRight} />
              </Icon>
            )}
          </>
        ))}
      </P>
    </Div>
  )
}

Breadcrumb.propTypes = {
  pages: PropTypes.array.isRequired
}

Breadcrumb.defaultProps = {
  pages: []
}

export default Breadcrumb
